module.exports = __webpack_public_path__ + "img/制御工学6_6_4.0aca1a89.png";